import { css } from "styled-components";

interface IconContainerProps {
  active: boolean;
}

const InputHourIconContainer = css <IconContainerProps>`
  position: absolute;
  z-index: 2;
  left: 15px;
  top: 53%;
  transform: translateY(-50%);
  svg {
    width: 20px;
    height: 20px;
    fill: #8295A3;
  }
  ${({ active }) => active && `
    svg {
      fill: #5DC5EA;
      g {
        fill: #5DC5EA;
      }
    }
  `}
`;


export default InputHourIconContainer;
